import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import WalletTransactions from "./containers/wallet-transactions";
import WalletImpTransactions from "./containers/wallet-imp-transactions";
import WalletSummary from "./containers/wallet-summary";

export default function WalletHistoryRoutes({ match }) {
    return (
        <Switch>
            <Route exact path={`${match.url}/transactions`} component={WalletTransactions} />
            <Route exact path={`${match.url}/imp-transactions`} component={WalletImpTransactions} />
            <Route exact path={`${match.url}/summary`} component={WalletSummary} />
            <Redirect to={`${match.url}/transactions`} />
        </Switch>
    );
}
